export const rotate = <T>(
  operativeArray: T[],
  iterations: number,
  inverse: boolean = false
): T[] => {
  const arrayCopy: T[] = [...operativeArray];
  if (iterations > 0) {
    for (let i = 0; i < iterations; i++) {
      inverse === true
        ? arrayCopy.push(arrayCopy.shift())
        : arrayCopy.unshift(arrayCopy.pop());
    }
  }
  if (iterations < 0) {
    for (let i = 0; i < Math.abs(iterations); i++) {
      inverse === true
        ? arrayCopy.unshift(arrayCopy.pop())
        : arrayCopy.push(arrayCopy.shift());
    }
  }
  return arrayCopy;
};
